export const getTagSlug = (tag: string): string => {
  return tag.toLowerCase().trim().split(" ").join("-");
};

export const getRandomColorFromColors = (): string => {
  const colorArray = ["#D6F5FF", "#D1DEF7"];
  return colorArray[Math.floor(Math.random() * colorArray.length)];
};
